import { FormControlLabel, Toggle } from '@moonpig/launchpad-forms'
import React, { useEffect, useState } from 'react'
import { breakpointUp, styled } from '@moonpig/launchpad-utils'
import { system as s } from '@moonpig/launchpad-system'
import { useFindLocaleText } from '../../text-localisation'
import {
  CookieCategory,
  getBrowserCookie,
  setBrowserCookie,
} from '@moonpig/web-core-browser-storage'
import { MULTI_BUY_COOKIE_NAME } from '../../constants'
import { useSearchStore } from '../../store/SearchStore'
import {
  trackGAEvent,
  createGenericSelectContentEvent,
} from '@moonpig/web-core-analytics'

const StyledFormControlLabel = styled(FormControlLabel)`
  width: 100%;
  span {
    ${s({
      typography: 'typeBodyLabel',
      fontWeight: '700',
      color: 'colorTextLabel',
    })}
  }
    
  ${breakpointUp('md')} {
    width: auto;
  }

  > div:first-child {
    transform: scale(0.75);
    transform-origin: right center;
    margin-left: -16px;
  }
`

export const MultiBuyToggle = () => {
  const localiseText = useFindLocaleText()
  const [isMultiBuyEnabled, setIsMultiBuyEnabled] = useState(false)
  const toggleMultiBuyEnabled = useSearchStore(
    store => store.toggleMultiBuyEnabled,
  )

  const multiBuyToggleDescription = localiseText('find.multi_buy')

  useEffect(() => {
    const multiBuyCookieState =
      getBrowserCookie(MULTI_BUY_COOKIE_NAME) === 'true'

    setIsMultiBuyEnabled(multiBuyCookieState)
    toggleMultiBuyEnabled(multiBuyCookieState)
  }, [toggleMultiBuyEnabled])

  const handleMultiBuyEnabled = (isEnabled: boolean) => {
    setIsMultiBuyEnabled(!isEnabled)
    setBrowserCookie(
      MULTI_BUY_COOKIE_NAME,
      JSON.stringify(!isEnabled),
      { path: '/' },
      CookieCategory.STRICTLY_NECESSARY,
    )
    toggleMultiBuyEnabled(!isEnabled)
    trackGAEvent(
      createGenericSelectContentEvent({
        eventCategory: 'multibuy list',
        eventAction: !isEnabled ? 'toggle enabled' : 'toggle disabled',
        eventLabel: `multibuy list entry point toggle`,
      }),
    )
  }

  return (
    <StyledFormControlLabel
      id="multi-buy-toggle"
      data-testid="multi-buy-toggle"
      label={multiBuyToggleDescription}
      labelPosition="left-justified"
      reducedWidth
    >
      <Toggle
        onChange={() => {
          handleMultiBuyEnabled(isMultiBuyEnabled)
        }}
        value="multi-buy-toggle"
        checked={isMultiBuyEnabled}
      />
    </StyledFormControlLabel>
  )
}
